import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import CryptoJS from "crypto-js";

import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

import "react-tabs/style/react-tabs.css";
import ViewAudiences from "./ViewAudiences";
//import "assets/scss/styles.css";
import "assets/scss/responsive.css";
import "./customstyle.css";

class CustomerTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      localStorageClientId: "",
      channelName: "Eclub",
    };
  }

  componentDidMount() {
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });

    let channelId = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("activeChannel"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );

    if (
      channelId === "g786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      channelId === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
      channelId === "0417f699-bdd9-473d-873f-499e1c86efac" ||
      channelId === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" ||
      channelId === "3c8a9cf7-a0b2-4845-8436-d598181e6d78"
    ) {
      this.setState({
        channelName: "Loyalty",
      });
    }
    else if(
      channelId === "33bc71b1-4495-43f0-ab64-17ed38270e04"
    ) {
      this.setState({
        channelName: "SMS",
      });
    } 
    else if (
      channelId === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
      channelId === "92ec41c7-6724-4891-bc17-24981a3261dd" ||
      channelId === "25c7cb9a-a192-46f5-b32d-49e8d52afea8" ||
      channelId === "c2a842ba-36cc-46b7-8fa4-3a361708b34b" 
    ) {
      this.setState({
        channelName: "Eclub",
      });
    } else if (channelId === "d1606aea-0c0d-4fba-83e8-a124f414a953") {
      this.setState({
        channelName: "Display",
      });
    } else if (channelId === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      this.setState({
        channelName: "Guest Connect",
      });
    } else if (channelId === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      this.setState({
        channelName: "OLO",
      });
    } else if(channelId === "1d337d2d-e23a-445a-bda6-2405dbb79dcc") {
      this.setState({
        channelName: "Loyalty-Hubspot",
      });
    } else if(channelId === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91") {
      this.setState({
        channelName: "Email",
      });
    } else if(
        channelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" || 
        channelId === "2c77a7b6-60e9-4c75-819e-e93b60d47b82"
      ) {
      this.setState({
        channelName: "Direct Mail",
      });
    }
  }

  numberWithCommas(x) {
    return x != undefined
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  }

  render() {
    if (this.state.redirect === true) {
      return <ViewAudiences />;
      // <Redirect push to={"/audiences/createAudiences/"} />;
    }
    return (
      <div className="dashboardMargin">
        <div className="audienceinfo-c" style={{ backgroundColor: "#eeeeee" }}>
          {/* <div
            className="rightsidecontent-c"
            style={{ backgroundColor: "#eeeeee" }}
          > */}
          <div
            className={
              this.state.localStorageClientId ===
              "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
                ? "rightsidecontent-c-goodwill"
                : "rightsidecontent-c"
            }
            style={{ backgroundColor: "#eeeeee" }}
          >
            <ul className="righttopcontent-c">
              {/*<li
                className={
                  this.props.activeTab === "CustSource"
                    ? "righttopcontent-li-active-c"
                    : "righttopcontent-li-c"
                }
              >
                <a
                  onClick={() => this.props.handleclick("CustSource")}
                  className={
                    this.props.activeTab === "CustSource"
                      ? "summaryinfo-active-c"
                      : "summaryinfo-c"
                  }
                >
                  <center>
                    <h2 className="capitalize">Customer Source</h2>
                  </center>
                </a>
              </li>*/}

              <li
                className={
                  this.props.activeTab === "Filter"
                    ? "righttopcontent-li-active-c"
                    : "righttopcontent-li-c"
                }
              >
                <a
                  onClick={() => this.props.handleclick("Filter")}
                  className={
                    this.props.activeTab === "Filter"
                      ? "summaryinfo-active-c"
                      : "summaryinfo-c"
                  }
                >
                  <center>
                    <h2 className="capitalize">filters</h2>
                    {/* <span>
              <i className="fa fa-check tick" aria-hidden="true" />
              
            </span> 
              <small>{this.numberWithCommas(this.props.showChartSpinner)} audience members</small>*/}
                  </center>
                </a>
              </li>
              <li
                className={
                  this.props.activeTab === "Segment"
                    ? "righttopcontent-li-active-c"
                    : "righttopcontent-li-c"
                }
              >
                <a
                  onClick={() => this.props.handleclick("Segment")}
                  className={
                    this.props.activeTab === "Segment"
                      ? "summaryinfo-active-c"
                      : "summaryinfo-c"
                  }
                >
                  <center>
                    <h2 className="capitalize">
                      {/*this.props.customerSegmentData.length*/} segments
                    </h2>
                  </center>
                  {/* <span>
              <i className="fa fa-check tick" aria-hidden="true" />
              segments
            </span> */}
                </a>
              </li>

              <li
                className={
                  this.props.activeTab === "Summary"
                    ? "righttopcontent-li-active-c"
                    : "righttopcontent-li-c"
                }
              >
                <a
                  onClick={() => this.props.handleclick("Summary")}
                  className={
                    this.props.activeTab === "Summary"
                      ? "summaryinfo-active-c"
                      : "summaryinfo-c"
                  }
                >
                  <center>
                    <h2 className="capitalize">summary</h2>
                    {/* <span>
                    <i className="fa fa-check tick" aria-hidden="true" />{" "}
                    
                  </span> */}
                    {this.props.lastModifiedDate != "" ? (
                      <small>last saved on {this.props.lastModifiedDate}</small>
                    ) : (
                      ""
                    )}
                  </center>
                </a>
              </li>

              <div
                style={{
                  display: "inline-block",
                  justifyContent: "center",
                  float: "right",
                }}
              >
                <Button
                  className="btn btncreate"
                  // className="buttonRight"
                  color="secondary"
                  onClick={(e) => this.props.submitQuery(e, false)}
                  style={{ marginRight: "4px" }}
                >
                  Save
                </Button>
                <Button
                  className="btn btncreate"
                  //className="buttonRight"
                  color="secondary"
                  onClick={() => this.setState({ redirect: true })}
                  style={{ marginRight: "4px" }}
                >
                  Cancel
                </Button>
              </div>
              <div style={{ display: "inline-block", float: "right" }}>
                <Button
                  className="btn btncreate"
                  // className="buttonRight"
                  color="secondary"
                  onClick={(e) => this.props.submitQuery(e, true)}
                  style={{ marginRight: "4px" }}
                >
                  Save and close
                </Button>
              </div>
            </ul>

            <div className="filtercentercontent summarycontent">
              <div
                className="filteraudiencetitle summarytitle"
                style={{
                  width: "35%",
                  marginTop: "10px",
                  minHeight: "40px",
                  background: "#A9A9A9",
                  borderRadius: "0px",
                }}
              >
                <h5 className="capitalize" style={{ color: "white" }}>
                  Audience : Customer {">"} Channel : {this.state.channelName}
                </h5>
              </div>
            </div>

            <div className="filtercentercontent">{this.props.content}</div>
          </div>
        </div>{" "}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  /*count: state.count,
    tillSqlSelectionArr: state.tillSqlSelectionArr,
    afterSqlSelectionArr: state.afterSqlSelectionArr,
    ruleLeveltoggle: state.ruleLeveltoggle,
    groupLeveltoggle: state.groupLeveltoggle,
    title: state.title,
    listDescription: state.listDescription,
    queryCount: state.queryCount,
    showQuerySpinner: state.showQuerySpinner,
    previewData: state.previewData,
  
    countSegment: state.countSegment,
    tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
    afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
    ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
    groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  
    queryCountSegment: state.queryCountSegment,
    showQuerySpinnerSegment: state.showQuerySpinnerSegment,
    previewDataSegment: state.previewDataSegment,
    segmentName: state.segmentName,
    segmentData: state.segmentData,
    hideTabs: state.hideTabs,
    sliderValue: state.sliderValue,
    queryCountTempSegment: state.queryCountTempSegment*/
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(CustomerTabs)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/CustomerTabs.jsx